module.exports = __webpack_public_path__ + "static/img/W.9a8e28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/W.png
// module id = wfqu
// module chunks = 0